module.exports = __webpack_public_path__ + "static/media/gray-voice-recorder.b44c8f49.svg";